import React, { useState } from 'react'
import Select from "react-select"
import moment from "moment"
import { Checkbox, DatePicker, Dropdown, Menu } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'

import Receive from '../components/resusable/receive'

import { usePet, useQuery, normalize, stringifyDate, useToggle, server, useListData } from '../modules'
import SalesReport from '../components/modals/salesreport'
import ByStaff from '../components/modals/byStaff'
import ByPaymentMethod from '../components/modals/byPaymentMethod'
import EndofDay from '../components/modals/endOfDay'

const { RangePicker } = DatePicker

const Transactions = () => {
    const query = useQuery()

    const [string, setString] = useState('')
    const [shft, setShift] = useState()
    const [str, setStr] = useState('')
    const [transactions, setTransactions] = useState([])
    const [ranges, setRanges] = useState([moment().startOf('day'), moment().endOf('day')])
    const [origins, setOrigins] = useState([])
    const [origin, setOrigin] = useState({ label: 'All Stations', value: 'All' })
    const [method, setMethod] = useState({ label: 'All', value: 'All' })

    const [dateRange, toggleDateRange] = useToggle()

    let methods = ['All', 'Cash', 'M-Pesa', 'PDQ']

    const rangesOK = ranges?.length === 2 && ranges[0] && ranges[1]

    const [
        { loading: sLoading, error: sError, fetch },
        { list: shifts = [] },
    ] = useListData('allShifts', { string: str }, { notify: true }, 'shifts')

    const [{ loading, error, data }, getTransactions] = usePet('transactions',
        ranges?.length === 2 && rangesOK ? 
            { 
                method: method?.value === 'All' ? '' : method?.value,
                string,
                from: ranges[0]?._d ?? ranges[0], 
                to: ranges[1]?._d ?? ranges[1] 
            }
        : {}
    , { notify: true, callback: ({ data }) => setTransactions(data), manual: !(ranges?.length === 2), manual: ranges?.length !== 2 || !ranges[0] || !ranges[1] })

    const toggleRange = () => {
        setRanges([moment().startOf('day'), moment().endOf('day')])
        setShift()
        if (!dateRange)
            getTransactions()
        toggleDateRange()
    }

    const search = str => {
        setString(str)
        getTransactions()
    }

    const changeMethod = val => {
        setString('')
        setMethod(val)
        getTransactions()
    }

    const selectRange = range => {
        range = range ?? [moment(), moment()]

        setString('')
        setRanges(range)
        getTransactions()
    }

    const selectShift = shift => {
        setShift(shift)
        selectRange([moment(shift.start), moment(shift.end ?? new Date())])
    }

    let period = rangesOK && String(ranges[0]) === String(ranges[1]) ? `For ${stringifyDate(ranges[0]?._d, true)}` : `From ${stringifyDate(ranges[0]?._d, true)} To ${stringifyDate(ranges[1]?._d, true)}`

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="sm:flex sm:justify-between sm:items-between mb-8">
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end items-center gap-2">
                    <input
                        onChange={ e => search(e.target.value) }
                        value={ string }
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-inv-item"
                        type="text"
                        placeholder="Search using bill Ref, " />
                </div>
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end items-center gap-2">
                    <Checkbox 
                        value={ dateRange } 
                        onChange={ toggleRange }>Use Date Range</Checkbox>
                    {
                        dateRange ?
                            <RangePicker 
                                value={ ranges } 
                                showTime 
                                onChange={selectRange}
                                ranges={{
                                    'Today': [moment().startOf('day'), moment().endOf('day')],
                                    'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                                    'This Week': [moment().startOf('week'), moment().endOf('week')],
                                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                                }}/>
                        :
                            <Select
                                value={ shft }
                                onChange={ selectShift }
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ shifts.map(({ _id, user, start, date, end }) => ({
                                    user,
                                    label: `${user.name} (${stringifyDate(date)}${end ? ` - ${stringifyDate(end)}` : '' })`,
                                    value: _id,
                                    date,
                                    start,
                                    end
                                })) }
                                placeholder="Select Shift" />
                    }
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                {
                    rangesOK ?
                        <>
                            <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                                <h2 className="font-semibold mb-0 text-gray-800">{ method?.label } Transactions { period }</h2>
                                <div className="grid grid-flow-col sm:auto-cols-max items-center justify-start sm:justify-end gap-2">
                                    <Select
                                        value={ method }
                                        onChange={ changeMethod }
                                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                        options={ methods.map(mth => ({ label: mth, value: mth })) }
                                        placeholder="Select Method" />
                                </div>
                            </header>
                            <div className="p-3">

                                {/* Table */}
                                <div className="overflow-x-auto">
                                    <Receive
                                        error={error}
                                        loading={loading}
                                        progress>
                                        {
                                            transactions.length > 0 ?
                                                <table className="table-auto w-full">
                                                    {/* Table header */}
                                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                        <tr>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-center">No</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Method</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Amount</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Bill Details</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Received By</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Date</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-center"></div>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    {/* Table body */}
                                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                        {
                                                            transactions.map((payment, key) =>
                                                                <tr>
                                                                    <td className="p-2">
                                                                        <div className="text-center">{key + 1}.</div>
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="">{ payment.method }</div>
                                                                        <p className="text-gray-500 text-xs italic">{ payment.description }</p>
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="">Ksh. { Math.abs(payment.amount) }</div>
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="">#{ payment.bill.orderNo }</div>
                                                                        <p className="text-gray-500 text-xs italic">Handled by { payment?.servedBy?.name }</p>
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="">{ payment?.recordedBy?.name }</div>
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="">{ stringifyDate(payment.date) }</div>
                                                                    </td>
                                                                    <td className="p-2">
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            :
                                                <div className="flex py-10 font-semibold text-md justify-center items-center">
                                                    <h2>No { method?.value === 'All' ? '' : method?.value } transactions have been recorded for { period }</h2>
                                                </div>
                                        }
                                    </Receive>
                                </div>
                            </div>
                        </>
                    :
                        <div className="flex py-10 font-semibold text-md justify-center items-center">
                            <h2>Please select a date range</h2>
                        </div>
                }
            </div>
        </div>
    )
}

export default Transactions